<template>
	<img class="logo" :src="image" alt="Letbane" />
</template>

<script>
export default {
	computed: {
		image() {
			return require('@/apps/fynbus/assets/images/letbane-logo.svg')
		},
	},
}
</script>

<style scoped>
.logo {
	width: 7.125rem;
	aspect-ratio: 2.5rem / 7.125rem;
}
</style>
